module.exports = __webpack_public_path__ + "static/img/1d.de6ad38.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/1d.jpg
// module id = hni9
// module chunks = 0